<template>
  <div
    class="cursor"
    :class="{'cursor--hovering': hovering, 'cursor--dark-mode': darkMode}">
    <div ref="cursorHead" class="cursor__head" />
    <div ref="cursorTail" class="cursor__tail">
      Go!
    </div>
  </div>
</template>

<script>
import gsap from 'gsap';
import { useInterfaceStore } from '../../../store/interface.js';

export default {
  data() {
    return {
      active: false,
      posX: 0,
      posY: 0,
      mouseX: 0,
      mouseY: 0,
      hovering: false,
      darkMode: false,
    };
  },
  async created() {
    this.interface = useInterfaceStore();
  },
  mounted() {
    const component = this;
    let allButtons;
    let allDarkSections;

    gsap.to({}, 0.0025, {
      repeat: -1,
      onRepeat: () => {
        this.posX += (this.mouseX - this.posX) / 27;
        this.posY += (this.mouseY - this.posY) / 27;

        gsap.set(this.$refs.cursorTail, {
          css: {
            left: this.posX + 10,
            top: this.posY + 10,
          },
        });

        gsap.set(this.$refs.cursorHead, {
          css: {
            left: this.mouseX,
            top: this.mouseY,
          },
        });
      },
    });

    document.addEventListener('mousemove', (e) => {
      this.mouseX = e.pageX;
      this.mouseY = e.pageY;
    });

    allButtons = document.querySelectorAll('button, a');

    allDarkSections = document.querySelectorAll('.background--blue, .background--latenight, .background--bluescale-950, .footer');

    allButtons.forEach((button) => {
      button.addEventListener('mouseenter', () => {
        component.interface.setCursorHover(true);

        component.hovering = true;
      });

      button.addEventListener('mouseleave', () => {
        component.interface.setCursorHover(false);

        component.hovering = false;
      });

      // document.body.addEventListener('click', () => {
      //   component.interface.setCursorHover(true);

      //   component.hovering = true;

      //   setTimeout(() => {
      //     component.hovering = false;
      //   }, 1000);
      // });

      button.addEventListener('mouseleave', () => {
        component.interface.setCursorHover(false);

        component.hovering = false;
      });
    });

    allDarkSections.forEach((section) => {
      section.addEventListener('mouseenter', () => {
        component.darkMode = true;
      });

      section.addEventListener('mouseleave', () => {
        component.darkMode = false;
      });
    });
  },
};
</script>
